const projects = [
          { "title": "For Reddit, to Go", 
                    "tagline": "Listen to Reddit while getting stuff done - through the power of Text to Speech. Only works in Chrome and Firefox.",
                    "features": [ "basic reddit functionality", "log in with reddit", "text-to-speech", "basic audio player features like skip, back, pause" ],
                    "thumbnail": "rtg_bg.png",
                    "images": [ "rtg_bg.png" ],
                    "link": "https://raphaelmayer.github.io/ForRedditToGo",
                    "repo": "https://github.com/raphaelmayer/ForRedditToGo",
                    "tech": ["react.js", "javascript", "Web Speech API"],
                    "type": "front end"
                    },
//
/*				  { "title": "Jonny Hill", 
                    "tagline": "Designed and developed a new homepage with a store front and CMS capabilities.",
                    "features": [ "e-commerce", "persistent shopping cart", "integrated payment options", "automated emails", "admin interface" ],
                    "thumbnail": "jh.jpg",
                    "images": [ "jh-front.jpg" ],
                    "link": "https://jonny-hill.info",
                    "repo": "",
                    "tech": ["react.js", "node.js", "mysql", "strapi", "braintree"],
                    "type": "full stack"
                    },*/
//
                  { "title": "Crawl-Unsplash-CLI", 
                    "tagline": "Small command line utility for crawling and downloading royalty-free images from unsplash.com.",
                    "features": [ "query images by category", "download images", "ensures unique directories recursively" ],
                    "thumbnail": "crawl-unsplash-cl_bg.jpg",
                    "images": [ "crawl-unsplash-cl_bg.jpg", "crawl.jpg" ],
                    "link": "",
                    "repo": "https://github.com/raphaelmayer/crawl-unsplash-cl",
                    "tech": ["node.js"],
                    "type": "misc"
                    },
//
                  { "title": "Get Me a Goddamn Movie!", 
                    "tagline": "My girlfriend and I spent way too much time scrolling through Netflix to find something to watch. You just can't judge a movie by its cover! Consult ratings and movie trailers with ease to make an educated desicion.",
                    "features": [ "search by actor or movie name", "pagination", "trailer" ],
                    "thumbnail": "gmagm_bg2.png",
                    "images": [ "GMAGM3.jpg",
                                "GMAGM.jpg",
                                "GMAGM1.jpg", ],
                    "link": "https://raphaelmayer.github.io/Get-Me-a-Goddamn-Movie",
                    "repo": "https://github.com/raphaelmayer/Get-Me-a-Goddamn-Movie",
                    "tech": ["react.js"],
                    "type": "front end" 
                    },
//
                  { "title": "Weather App", 
                    "tagline": "Lightweight, mobile-first web app to check your local weather or any location by name or ZIP-code in real time.",
                    "features": [ "weather info by query or GPS", "5 day forecast", "celsius and fahrenheit"],
                    "thumbnail": "weatherApp_bg.png",
                    "images": [ "weatherApp.png", "weatherApp_mobile.png" ],
                    "link": "https://raphaelmayer.github.io/weather-app",
                    "repo": "https://github.com/raphaelmayer/weather-app",
                    "tech": ["javascript"], 
                    "type": "front end"
                  },
//
                  { "title": "Simon Game", 
                    "tagline": "Simon Says is a classic game where the player has to reproduce a given sequence of button presses. With animation and sound.",
                    "features": [ "FUN!", "hard mode" ],
                    "thumbnail": "simon_bg.png",
                    "images": [ "simon-game.jpg" ],
                    "link": "https://raphaelmayer.github.io/simon-game",
                    "repo": "https://github.com/raphaelmayer/simon-game",
                    "tech": ["javascript"],
                    "type": "front end"
                    },
//
                  { "title": "Choropleth Visualization", 
                    "tagline": "A map showing percentages of adults of age 25 and older with a bachelor's degree or higher (2010-2014)",
                    "features": [ "interactive: hover for more info" ],
                    "thumbnail": "choro_bg.png",
                    "images": [ "choro_bg.png" ],
                    "link": "https://raphaelmayer.github.io/choropleth_map",
                    "repo": "https://github.com/raphaelmayer/choropleth_map",
                    "tech": ["d3.js", "javascript"], 
                    "type": "misc"
                    },
// 
                    { "title": "YouVote - create and share polls", 
                    "tagline": "YouVote is a web application where users can create and save custom polls and share them with people online.",
                    "features": [ "Authentication", "basic CRUD operations"],
                    "thumbnail": "youvote-preview.jpg",
                    "images": [ "youvote-explore.png",
                                "youvote-main.png",
                                "youvote-new.png",
                                "youvote-poll.png",
                                "youvote-my.png" ],
                    "link": "https://raphaelmayer.github.io/youvote",
                    "repo": "https://github.com/raphaelmayer/Voting-App",
                    "tech": ["react.js", "node.js", "mongoDB"],
                    "type": "full stack"
                  },
//
                  { "title": "tbd", 
                    "tagline": "A platform to share and sell gigs.",
                    "features": [ "authentication", "messaging", "rating system" ],
                    "thumbnail": "placeholder.jpg",
                    "images": [ "placeholder.jpg" ],
                    "link": "",
                    "repo": "https://github.com/raphaelmayer/food-share",
                    "tech": ["react.js", "node.js", "redux", "mongoDB"], 
                    "type": "full stack"
                    },
//
                  { "title": "tbd", 
                    "tagline": "A platform to share and sell gigs.",
                    "features": [ "authentication", "messaging", "rating system" ],
                    "thumbnail": "placeholder.jpg",
                    "images": [ "placeholder.jpg" ],
                    "link": "",
                    "repo": "https://github.com/raphaelmayer/food-share",
                    "tech": ["react.js", "node.js", "mongoDB", "redux", "mongoDB", "react.js", "node.js", "redux"], 
                    "type": "full stack"
                    },
//
/*                  { "title": "QuoteFactory", 
                    "tagline": "Coming soon - Realtime quote image generator with loads of options including font styles, filters and animations.",
                    "features": [ "Coming soon" ],
                    "thumbnail": "placeholder.jpg",
                    "images": [ "placeholder.jpg" ],
                    "link": "",
                    "repo": "",
                    "tech": ["full stack", "react.js", "node.js"]}, 
                    "type": "misc" */
];
//
export default projects;